import { render } from "./OrdersView.vue?vue&type=template&id=3c58de5f&scoped=true"
import script from "./OrdersView.vue?vue&type=script&lang=js"
export * from "./OrdersView.vue?vue&type=script&lang=js"

import "./OrdersView.vue?vue&type=style&index=0&id=3c58de5f&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c58de5f"]])

export default __exports__